import React from "react";

type DiffCounts = {
  additions: number;
  deletions: number;
}

// eslint-disable-next-line no-control-regex
const ANSI_ESCAPE_PATTERN = /\x1b\[[0-9;]*m/g;

export const ansiToReact = (input: string): { segments: React.ReactNode[], counts: DiffCounts } => {
  const segments: React.ReactNode[] = [];
  const counts: DiffCounts = { additions: 0, deletions: 0 };

  const lines = input.split('\n');
  
  lines.forEach((line, lineIndex) => {
    let currentColor: string | undefined = undefined;
    const processedLine = line.replace(ANSI_ESCAPE_PATTERN, '');
    
    if (processedLine.startsWith('-') || line.startsWith('\x1b[31m')) {
      currentColor = 'red';
      counts.deletions++;
    } else if (processedLine.startsWith('+') || line.startsWith('\x1b[32m')) {
      currentColor = 'green';
      counts.additions++;
    }

    segments.push(
      <pre 
        style={{ 
          color: currentColor, 
          margin: 0,
          whiteSpace: 'pre',
          display: 'inline'
        }} 
        className={currentColor === 'red' || currentColor === 'green' ? 'font-semibold' : ''}
        key={`${lineIndex}`}
      >
        {processedLine}
      </pre>
    );
    
    if (lineIndex < lines.length - 1) {
      segments.push(<br key={`br-${lineIndex}`} />);
    }
  });

  return { segments, counts };
};
